<div class="button__content">
    <ng-container *ngIf="canDisplayContent$ | async">
        <ng-content></ng-content>
    </ng-container>
    <img
            *ngIf="canDisplayLoadingSpinner$ | async"
            class="button__loading-spinner"
            [src]="appearance === 'flat' ? 'assets/img/spinner-white.png' : 'assets/img/spinner-green.png' "
            alt="button spinner"
    />
    <svg-icon
            class="button__success-icon"
            *ngIf="canDisplaySuccessIcon$ | async"
            src="assets/icons/check.svg"
    ></svg-icon>

</div>